/**
 * This code was generated by Builder.io.
 */
import React, { useState } from "react";
import styles from "./TableStyles.module.css";
import AdjustmentDetails from "../AdjustmentDetails/AdjustmentDetails";

interface RowData {
  office: string;
  period: string;
  status: string;
  lastUpdate: string;
}

interface TableRowProps {
  data: RowData;
  isSelected: boolean;
  onSelect: (isSelected: boolean) => void;
}

const TableRow: React.FC<TableRowProps> = ({ data, isSelected, onSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(event.target.checked);
  };

  const handleAccordionClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <article className={styles.tableRow}>
      <div className={styles.rowContent}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleCheckboxChange}
          className={styles.checkbox}
          aria-label={`Select ${data.office}`}
        />
        <p className={styles.officeInfo}>{data.office}</p>
      </div>
      <div className={styles.officeInfo}> <span>{data.period}</span></div>
      <div className={styles.officeInfo}> <span>{data.status}</span></div>
      <div className={styles.officeInfo}> <span>{data.lastUpdate}</span></div>
        <div className={styles.rowDetails}>
        {/* <span>{data.status}</span>
        <span>{data.lastUpdate}</span> */}
        <button
          onClick={handleAccordionClick}
          className={styles.accordionButton}
          aria-expanded={isExpanded}
          aria-label="Toggle accordion"
        >
          <span
            className={`${styles.accordionIcon} ${
              isExpanded ? styles.expanded : ""
            }`}
          >
            ▼
          </span>
        </button>
      </div>
      {isExpanded && (
        <div className={styles.expandedContent}>
          <AdjustmentDetails lastUpdated={"08/06/2024"} periodEnding={"10/2024"} totalBorrowerFees={"$100.00"} cuRetailRate={"$4.00/1000"} protectedLoanAmount={"$25,000"} payRate={"$1.50/1000"} premiumDue={"$37.50"} totalAmount={"$37.50"} adjustmentType={""} adjustmentDescription={"Withdrawl from CU"}/>
          {/* <p>Additional information for {data.office}</p> */}
        </div>
      )}
    </article>
  );
};

export default TableRow;
